export class LeftMenuItem {
    label: string;
    route: string;
    isSelected: boolean;
    isDropdown: boolean;
    childrenItems: LeftMenuItem[];

    constructor() {};
}